<template>
    <div>
        <!-- 搜索条件 -->
        <div class="whiteBox" style="display: flex;justify-content: space-between; flex-wrap: wrap;">
            <div style="display: flex;align-items: center;">
                <el-input v-model="form.sectionName" :placeholder="$t('view.招标项目/招标单位')" style="flex: 1;" size="mini"></el-input>
            </div>
            <div style="display: flex;align-items: center;">
                 <span>{{ $t('view.项目状态：') }}</span>
                <el-select size="mini" clearable v-model="form.status"  style="flex: 1; ">
                    <el-option v-for="item in material_part_status" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                </el-select>
            </div>
            <div>
                <el-button size="mini" type="primary" @click="form.pageNum=1; getMaterialPartBySupplier()">{{ $t('view.搜索') }}</el-button>
                <el-button size="mini" style="margin: 0 10px;" @click="resetting">{{$t('view.重置')}}</el-button>
            </div>

        </div>
        <div style="background: #fff;padding: 20px; margin-bottom: 20px;">
            <!-- 表格数据 -->
            <el-table header-row-class-name="tableHeader" :data="tableData" style="width: 1010px" border>
                <el-table-column align="center" type="index" width="60"  show-overflow-tooltip :label="$t('view.序号')"></el-table-column>
                <el-table-column prop="sectionName" show-overflow-tooltip :label="$t('view.招标项目名称')"></el-table-column>
                <el-table-column align="center" prop="organizationName" show-overflow-tooltip :label="$t('view.招标单位')"></el-table-column>
                <el-table-column align="center" prop="materialCode" show-overflow-tooltip :label="$t('view.物资编码')"></el-table-column>
                <el-table-column align="center" prop="materialName" show-overflow-tooltip :label="$t('view.物资名称')"></el-table-column>
                <el-table-column align="center" prop="personCharge" show-overflow-tooltip :label="$t('view.招标负责人')"></el-table-column>
                <el-table-column align="center" prop="date" show-overflow-tooltip :label="$t('view.状态')">
                    <template slot-scope="scope">
                        {{getStatus('material_part_status',scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="date" :width="locale=='zh'?150:locale=='lo'? 200:180" show-overflow-tooltip :label="$t('view.操作')">
                    <template slot-scope="scope">
                        <!-- 查看 -->
                        <span class="clickText" @click="questionGet(scope.row.id,'det')">{{ $t('view.查看') }}</span>
                        <!-- 处理 -->
                        <span class="clickText" @click="questionGet(scope.row.id,'edit')" style="margin: 0 10px;color:#B80008" v-if="scope.row.status==1||scope.row.status==5">{{ $t('view.处理') }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="text-align: center;width: 100%;margin-top: 20px;" layout="prev, pager, next"  :total="total" @current-change="handleCurrentChange"></el-pagination>
            <!-- </div> -->
        </div>

    </div>
  </template>
    
<script>
import {getDicts} from '@/api/index'
import {getMaterialPartBySupplier} from '@/api/PersonalCenter'
  export default {
    data(){
        return{
            tableData:[],
            total:0,
            material_part_status:[],
            value:'',
            locale: localStorage.getItem('locale')||'zh',
            form:{
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:10
            }
        }
    },
    created(){
        this.getDicts('material_part_status')
        this.getMaterialPartBySupplier()
    },
    methods:{
        // 字典项
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        // 详情
        questionGet(id,type){
            this.$router.push({
                path:'SparePartsDet',
                query:{id:id,type:type}
            })
        },
        // 重置
        resetting(){
            this.form={
                pageNum:1,
                createByName:'',
                companyName:'',
                sectionName:'',
                status:'',
                pageSize:10
            }
            this.TimeList=[]
            this.getMaterialPartBySupplier()
        },
        handleCurrentChange(e){
            this.form.pageNum=e
            this.getMaterialPartBySupplier()
        },
        getMaterialPartBySupplier(){
            getMaterialPartBySupplier(this.form).then(res=>{
                this.total=res.total
                this.tableData=res.rows
            })
        },  
    }
};
</script>
<style lang="scss" scoped>  
    .whiteBox span{
        color: #333333;
        font-size: 14px;
    }
    .whiteBox div{width:  30%;}
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
</style>
   